/**
 * Created by laszlo.czondor on 2018. 01. 19.
 */
import Multiselect from 'vue-multiselect';

export default {
	components: {
		Multiselect
	},
	data(){
		return {
			currentYear: this.defaultYear
		}
	},
	props: {
		defaultYear: {
			type: String,
			default: '' + new Date().getFullYear()
		}
	}
}



// WEBPACK FOOTER //
// ../source/modules/TAC01-terms-and-conditions/TAC01-terms-and-conditions.js